import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="page-hero compact">
      <p className="eyebrow">404</p>
      <h1>Page not found.</h1>
      <p>This route does not exist on the SZ Interactive website.</p>
      <Link className="button primary" to="/">Return home</Link>
    </section>
  );
}
